import React, { useEffect, useRef, useState } from "react";
import { Button, Badge, OrderStatus } from "./ui";
import { useParams, useNavigate } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardTitle, MDBTable, MDBTableBody, MDBTableHead, MDBIcon } from "mdb-react-ui-kit";
import { api } from "../services";
import { getImageUrl } from "../utils/utils";
import PriceDisplay from "./PriceDisplay";
import PrinterSettings from "./PrinterSettings";
import Actionbar from "./Actionbar";
import RightDrawer from "./RightDrawer";
import { useTranslation } from "react-i18next";
import PlatformLogo from "./ui/PlatformLogo";
// import {qzConnect, qzGetPrinters,qzPrintHtml} from "../utils/qz-utils"
// import qz from "qz-tray";
function ViewOrderDetails() {
  const {t,i18n} = useTranslation("translation");
  const isArabic = i18n.language === "ar"; 
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [printerConfigs, setPrinterConfigs] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [timelineOpen, setTimelineOpen] = useState(false);
  const [orderLogs, setOrderLogs] = useState([]);
  const [orderLogsData, setOrderLogsData] = useState();
  useEffect(() => {
    fetchOrderDetails();
    fetchPrinterConfigs();
  }, [orderId]);

  const fetchOrderDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get(`/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrderDetails(response.data.data);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch order details.");
    } finally {
      setLoading(false);
    }
  };
  const fetchOrderLogs = async () => {
    try{
      const token = localStorage.getItem("token");
     
      const response = await api.get(`/order/${orderDetails._id}/logs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrderLogsData(response.data);
 
      setOrderLogs(response.data.logs || [])
    } catch(err){
      setError(err.response?.data.message || "Failed to fetch order logs");
    }
  }
  const translateStatusTagline = (tagline, _status) => {
    const s = String(tagline || '').trim();
    if (!s) return '';
    const localizeEntityName = (name) => {
      const v = String(name || '').trim().replace(/\.$/, '');
      const l = v.toLowerCase();
      const platformKeys = {
        'jahez': 'platformName.JAHEZ',
        'keeta': 'platformName.KEETA',
        'ninja': 'platformName.NINJA',
        'the chefz': 'platformName.THE_CHEFZ',
        'ninja  - staging': 'platformName.NINJA_STAGING',
        'ninja - staging': 'platformName.NINJA_STAGING',
        'chat agent': 'platformName.CHAT_AGENT',
        'order agent': 'platformName.CHAT_AGENT',
        'digital catalog': 'platformName.DIGITAL_CATALOG',
        'digital_catalog': 'platformName.DIGITAL_CATALOG',
        'digitalcatalog': 'platformName.DIGITAL_CATALOG',
        'chat_agent': 'platformName.CHAT_AGENT',
      };
      if (platformKeys[l]) return t(platformKeys[l]);
      if (l === 'merchant') return t('actor.merchant');
      if (l === 'restaurant') return t('actor.restaurant');
      if (i18n.dir() === 'rtl') {
        if (['delivery courier', 'courier', 'delivery driver', 'driver'].includes(l)) return 'المندوب';
        if (['delivery service'].includes(l)) return t('actor.delivery_service');
      }
      return v;
    };
    const patterns = [
      { regex: /^Order received by the restaurant$/i, key: 'statusTagline.RECEIVED_RESTAURANT' },
      { regex: /^Order received from\s+(.+)\.?$/i, key: 'statusTagline.RECEIVED_FROM_PLATFORM', vars: (m) => ({ platform: localizeEntityName(m[1]) }) },
      { regex: /^Order accepted by logged-?in user or restaurant$/i, key: 'statusTagline.ACCEPTED_USER_OR_RESTAURANT' },
      { regex: /^Order accepted by\s+(.+)\.?$/i, key: 'statusTagline.ACCEPTED_BY_USER', vars: (m) => ({ user: localizeEntityName(m[1]) }) },
      { regex: /^Order ready by logged-?in user(.*)$/i, key: 'statusTagline.READY_OR_READY_FOR_DELIVERY' },
      { regex: /^Order ready by\s+(.+)\.?$/i, key: 'statusTagline.READY_BY_USER', vars: (m) => ({ user: localizeEntityName(m[1]) }) },
      { regex: /^(Order\s)?ready for delivery$/i, key: 'statusTagline.READY_OR_READY_FOR_DELIVERY' },
      { regex: /^Driver assigned to the order\.?$/i, key: 'statusTagline.DRIVER_ASSIGNED' },
      { regex: /^Driver assigned to order (\d+) \(([^)]+)\)$/i, key: 'reason.webhook.driver_assigned_to_order', vars: (m) => ({ orderId: m[1], platform: localizeEntityName(m[2]) }) },
      { regex: /^Driver assigned \(([^)]+)\)$/i, key: 'reason.webhook.driver_assigned', vars: (m) => ({ platform: localizeEntityName(m[1]) }) },
      { regex: /^Order delivered success(?:fully|full)\.?$/i, key: 'statusTagline.DELIVERED_SUCCESS' },
      { regex: /^Order cancelled by customer$/i, key: 'statusTagline.CANCELLED_BY_CUSTOMER' },
      { regex: /^Customer cancel(?:led|ed) the order\.?$/i, key: 'statusTagline.CANCELLED_BY_CUSTOMER' },
      { regex: /^Order cancelled by\s+(.+)\.?$/i, key: 'statusTagline.CANCELLED_BY_USER', vars: (m) => ({ user: localizeEntityName(m[1]) }) },
      { regex: /^Order rejected by logged-?in user or restaurant$/i, key: 'statusTagline.REJECTED_USER_OR_RESTAURANT' },
      { regex: /^Order rejected by (?:logged-?in )?user or restaurant\.?$/i, key: 'statusTagline.REJECTED_USER_OR_RESTAURANT' },
      { regex: /^Order rejected by\s+(.+)\.?$/i, key: 'statusTagline.REJECTED_BY_USER', vars: (m) => ({ user: localizeEntityName(m[1]) }) },
      { regex: /^Order timed out by system due to no response$/i, key: 'statusTagline.TIMED_OUT_SYSTEM' },
      { regex: /^Order timed out due to no response\s*\??\s*$/i, key: 'statusTagline.TIMED_OUT_NO_RESPONSE' },
      { regex: /^System unable to process the order action$/i, key: 'statusTagline.SYSTEM_UNABLE_TO_PROCESS' },
      { regex: /^Order accepted by delivery courier$/i, key: 'statusTagline.ACCEPTED_BY_COURIER' },
      { regex: /^Order has been processed$/i, key: 'statusTagline.PROCESSED' },
    ];
    for (const p of patterns) {
      const m = s.match(p.regex);
      if (m) {
        const vars = p.vars ? p.vars(m) : undefined;
        return t(p.key, vars);
      }
    }
    const r = translateReason(s);
    if (r && r !== s) return r;
    return s;
  };

// Add this helper function to your component
const mapLogsToTimeline = (logs) => {
  if (!logs || !Array.isArray(logs)) return [];

  // Map status to display text and icons
  const statusMap = {
    'PENDING': { text: t('statusText.PENDING'), icon: 'check', type: 'success' },
    'ACCEPTED': { text: t('statusText.ACCEPTED'), icon: 'file-circle-check', type: 'success' },
    'READY FOR DELIVERY': { text: t('statusText.READY FOR DELIVERY'), icon: 'check', type: 'success' },
    'OUT FOR DELIVERY': { text: t('statusText.OUT FOR DELIVERY'), icon: 'truck', type: 'info' },
    'DELIVERED': { text: t('statusText.DELIVERED'), icon: 'check-circle', type: 'success' },
    'REJECTED': { text: t('statusText.REJECTED'), icon: 'times', type: 'error' },
    'CANCELLED': { text: t('statusText.CANCELLED'), icon: 'times', type: 'error' },
    'TIME OUT': { text: t('statusText.TIME OUT'), icon: 'clock', type: 'timeout' },
    'RIDER ASSIGNED': { text: t('statusText.RIDER ASSIGNED'), icon: 'check', type: 'success' },
    'ACCEPTED BY COURIER': { text: t('statusText.ACCEPTED BY COURIER'), icon: 'check', type: 'success' },
  };

  return logs.map(log => {
    const statusInfo = statusMap[log.status] || { text: log.status, icon: 'info', type: 'info' };
    return {
      id: log._id,
      datetime: new Date(log.datetime),
      status: log.status,
      displayText: statusInfo.text,
      icon: statusInfo.icon,
      type: statusInfo.type,
      platform: log.platform,
      user: translateStatusTagline(log.status_tagline, log.status),
      reason: translateReason(log.platform_status_reason),
      performedBy: log.user?.email || 'System'
    };
  }).sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
};

/** Sum of each line’s `final_price` (same as order drawer / Keeta subtotal). */
const sumOrderLineFinalPrices = (products) =>
  (products || []).reduce((sum, p) => sum + (Number(p.final_price) || 0), 0);

/** Keeta Total paid = sum of Payment summary lines (all additive). */
const computeKeetaPaymentSummaryTotal = (order) => {
  const price = Number(order.customer_fees?.product_price ?? order.price ?? 0);
  const delivery = Number(order.customer_fees?.delivery_fee ?? 0);
  const platform = Number(order.merchant_fees?.platform_service_fee ?? 0);
  const tips = Number(order.customer_fees?.tips ?? 0);
  const topUp = Number(order.customer_fees?.top_up_amount ?? 0);
  return price + delivery + platform + tips + topUp;
};

/** Keeta merchant receives: price − bank/brokerage/activity + top-up (matches visible Merchant fees rows). */
const computeKeetaMerchantReceivesTotal = (order) => {
  const price = Number(order.merchant_fees?.product_price ?? order.price ?? 0);
  const topUp = Number(order.merchant_fees?.top_up_amount ?? 0);
  const bank = Number(order.merchant_fees?.bank_transaction_fee ?? 0);
  const brokerage = Number(order.merchant_fees?.brokerage_fee ?? 0);
  const activity = Number(order.merchant_fees?.activity_fee ?? 0);
  return price - bank - brokerage - activity + topUp;
};

  const fetchPrinterConfigs = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/printer-settings", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPrinterConfigs(response.data.data || []);
    } catch (err) {
      setPrinterConfigs([]);
    }
  };

  const handleBack = () => {
    navigate("/orders");
  };
  const handletimeline = async () => {
  try {
    await fetchOrderLogs();
    setTimelineOpen(true);
  } catch (error) {
    console.error('Failed to fetch order logs:', error);
    setError(t("Failed to load timeline"));
  }
};
  

// Convert logo to ESC/POS bit image (ESC * mode)
async function fetchImageAsEscPosBitImage(url, maxWidthPx = 384, threshold = 128) {
  const response = await fetch(url, { mode: "cors" });
  if (!response.ok) throw new Error("Failed to fetch logo: " + response.statusText);
  const blob = await response.blob();
  const imgBitmap = await createImageBitmap(blob);

  const scale = Math.min(1, maxWidthPx / imgBitmap.width);
  const width = Math.floor(imgBitmap.width * scale);
  const height = Math.floor(imgBitmap.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(imgBitmap, 0, 0, width, height);

  const imgData = ctx.getImageData(0, 0, width, height).data;
  const widthBytes = Math.ceil(width / 8);

  const result = [];
  for (let y = 0; y < height; y += 24) {
    const sliceHeight = Math.min(24, height - y);
    const nL = widthBytes & 0xff;
    const nH = (widthBytes >> 8) & 0xff;

    // ESC * m nL nH
    result.push(0x1b, 0x2a, 33, nL, nH);

    for (let x = 0; x < widthBytes; x++) {
      for (let k = 0; k < 24; k++) {
        let byte = 0;
        const yPos = y + k;
        if (yPos >= height) continue;
        for (let bit = 0; bit < 8; bit++) {
          const pixelX = x * 8 + bit;
          if (pixelX >= width) continue;
          const idx = (yPos * width + pixelX) * 4;
          const r = imgData[idx], g = imgData[idx + 1], b = imgData[idx + 2], a = imgData[idx + 3];
          const alpha = a / 255;
          const lum = (0.299 * r + 0.587 * g + 0.114 * b) * alpha + 255 * (1 - alpha);
          if (lum < threshold) byte |= 0x80 >> bit;
        }
        result.push(byte);
      }
    }
    result.push(0x0a); // line feed
  }

  return new Uint8Array(result);
}

// Uint8Array -> Base64
function uint8ToBase64(u8Arr) {
  const CHUNK = 0x8000;
  let index = 0, result = '';
  while (index < u8Arr.length) {
    const slice = u8Arr.subarray(index, Math.min(index + CHUNK, u8Arr.length));
    result += String.fromCharCode.apply(null, slice);
    index += CHUNK;
  }
  return btoa(result);
}

// Helper: convert Uint8Array to Base64
function uint8ToBase64(u8) {
  let binary = "";
  const chunkSize = 0x8000;
  for (let i = 0; i < u8.length; i += chunkSize) {
    const chunk = u8.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return btoa(binary);
}

// Helper: convert image to ESC/POS bit image (ESC * command)
async function fetchImageAsEscPosBitImage(url, maxWidth = 384) {
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.src = url;
  await img.decode();

  const scale = maxWidth / img.width;
  const width = maxWidth;
  const height = Math.floor(img.height * scale);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  const imageData = ctx.getImageData(0, 0, width, height);

  const bytes = [];
  const ESC = 0x1b;

  for (let y = 0; y < height; y += 24) {
    bytes.push(ESC, 0x2a, 33, width & 0xff, (width >> 8) & 0xff); // ESC * m nL nH
    for (let x = 0; x < width; x++) {
      for (let k = 0; k < 3; k++) {
        let slice = 0;
        for (let b = 0; b < 8; b++) {
          const yy = y + k * 8 + b;
          const i = (yy * width + x) * 4;
          let v = 0;
          if (yy < height) {
            const R = imageData.data[i];
            const G = imageData.data[i + 1];
            const B = imageData.data[i + 2];
            const luminance = 0.299 * R + 0.587 * G + 0.114 * B;
            v = luminance < 128 ? 1 : 0;
          }
          slice |= v << (7 - b);
        }
        bytes.push(slice);
      }
    }
    bytes.push(0x0a); // line feed
  }

  return new Uint8Array(bytes);
}

// Main print handler
const handlePrint = async () => {
  if (!orderDetails) return;

  if (!printerConfigs || !Array.isArray(printerConfigs)) {
    console.error("printerConfigs is not defined or not an array");
    alert("⚠️ No printer configuration available.");
    return;
  }

  const branchId = orderDetails.branch || orderDetails.branchId;

  const config = printerConfigs.find(
    (cfg) =>
      cfg.branchId === branchId || cfg.branchId === (branchId && branchId.toString())
  );

  if (!config) {
    console.warn("No matching printer configuration found for branch:", branchId);
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write("<h2>No printer configuration found for this branch.</h2>");
      printWindow.document.close();
    }
    return;
  }

 

  const numberOfCopies = config.numberOfCopies || 1;

  const createHtmlReceipt = () => {
    const logoHtml = config.logo
      ? `<img src="${config.logo}" alt="Logo" style="max-width:80px;max-height:80px;display:block;margin:0 auto 8px auto;" />`
      : "";

    const headerHtml = config.receipt_header
      ? `<div style="text-align:center;font-weight:bold;margin-bottom:8px;">${config.receipt_header}</div>`
      : "";

    const footerHtml = config.receipt_footer
      ? `<div style="text-align:center;font-size:12px;margin-top:12px;">${config.receipt_footer}</div>`
      : "";

    const orderRows = orderDetails.products
      .map(
        (product) => `
          <tr>
            <td>${product.quantity} x ${product.product_details?.name?.en || product.product_id}</td>
            <td style="text-align:right;">${product.final_price.toFixed(2)} ${config.currency || "SAR"}</td>
          </tr>
          ${
            product.modifiers && product.modifiers.length > 0
              ? product.modifiers
                  .map((mod) =>
                    mod.options
                      .map(
                        (opt) => `
                          <tr>
                            <td style='padding-left:16px;'>+ ${opt.quantity} x ${opt.nameEn}</td>
                            <td style='text-align:right;'>${opt.final_price.toFixed(2)} ${config.currency || "SAR"}</td>
                          </tr>
                        `
                      )
                      .join("")
                  )
                  .join("")
              : ""
          }
        `
      )
      .join("");

    const discountHtml = orderDetails.offer
      ? `<tr><td>Discount</td><td style='text-align:right;'>- ${orderDetails.offer.amount.toFixed(2)} ${config.currency || "SAR"}</td></tr>`
      : "";

    const subtotalHtml = config.receipt_show_subtotal
      ? `<tr><td>Subtotal</td><td style='text-align:right;'>${orderDetails.price.toFixed(2)} ${config.currency || "SAR"}</td></tr>`
      : "";

    const totalHtml = `<tr style='font-weight:bold;'><td>Total</td><td style='text-align:right;'>${orderDetails.final_price.toFixed(2)} ${config.currency || "SAR"}</td></tr>`;

    const branchName = config.branchName || orderDetails.branchName || "";
    const storeName = config.storeName || "";

    return `
      <html>
        <head>
          <title>Print Order</title>
          <style>
            body { font-family: Arial, sans-serif; background: #fff; margin: 0; padding: 0; }
            .receipt { margin: 0 auto; padding: 16px; border: 1px solid #eee; }
            .receipt h2 { text-align: center; margin: 0 0 8px 0; }
            .receipt table { width: 100%; border-collapse: collapse; margin-top: 8px; }
            .receipt td { padding: 4px 0; font-size: 14px; }
            .receipt .meta { font-size: 13px; margin-bottom: 8px; }
            .receipt .footer { margin-top: 16px; font-size: 12px; text-align: center; color: #888; }
            @media print {
              body { margin: 0; }
              .receipt { border: none; }
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            ${logoHtml}
            <h2>${storeName}</h2>
            <div class="meta">Branch: ${branchName}<br>Order #: ${orderDetails.order_id}<br>Date: ${formatDate(orderDetails.createdAt)}</div>
            ${headerHtml}
            <table>
              ${orderRows}
              ${discountHtml}
              ${subtotalHtml}
              ${totalHtml}
            </table>
            ${footerHtml}
            <div class="footer">Printer: ${config.printerType}</div>
          </div>
        </body>
      </html>
    `;
  };

  // --- Default Print Loop (desktop + Android) ---
  for (let i = 0; i < numberOfCopies; i++) {
    
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(createHtmlReceipt());
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  }
};

  const handleStatusUpdate = async (status) => {
    if (!orderDetails) return;
    setIsUpdating(true);
    try {
      const token = localStorage.getItem("token");
      await api.patch(
        `/orders/${orderDetails._id}/status`,
        {
          status,
          appId: orderDetails.appId?._id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      await fetchOrderDetails();
    } catch (err) {
      const apiData = err.response?.data || {};
      const detail =
        (String(i18n.language || "").startsWith("ar") && apiData.message_ar) ||
        apiData.message ||
        null;
      setError(detail || "Failed to update order status.");
    } finally {
      setIsUpdating(false);
    }
  };

  const getStatusBadge = (status) => (
    <OrderStatus status={status} uppercase={false}>
      {typeof status === "string" && status.length > 0 && status === status.toUpperCase()
        ? t(status)
        : status}
    </OrderStatus>
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const translateReason = (reason) => {
    if (!reason) return 'N/A';
    
    const translateReasonText = (reasonText) => {
      if (!reasonText) return '';
      const reasonLower = String(reasonText).toLowerCase().trim().replace(/^\.+|\.$/, '');
      const reasonTextMap = {
        'customer canceled the order': 'reasonText.customer_canceled_the_order',
        'customer rejected the order': 'reasonText.customer_rejected_the_order',
        'customer requests order cancellation': 'reasonText.customer_requests_cancellation',
        'out of stock': 'reasonText.out_of_stock',
        'item not available': 'reasonText.item_not_available',
        'store closed': 'reasonText.store_closed',
        'preparation time exceeded': 'reasonText.preparation_time_exceeded',
        'restaurant did not respond in time': 'reasonText.restaurant_did_not_respond',
        'order rejected by merchant': 'reasonText.order_rejected_by_merchant',
        'order cancelled by merchant': 'reasonText.order_cancelled_by_merchant',
        'order canceled by merchant': 'reasonText.order_cancelled_by_merchant',
        'order rejected by restaurant': 'reasonText.order_rejected_by_restaurant',
        'order cancelled by restaurant': 'reasonText.order_cancelled_by_restaurant',
        'order canceled by restaurant': 'reasonText.order_cancelled_by_restaurant',
      };
      const key = reasonTextMap[reasonLower];
      const translated = key ? t(key) : reasonText;
      return translated;
    };
    
    const normalizePlatform = (name) => {
      const v = String(name || '').trim().replace(/\.$/, '');
      const l = v.toLowerCase();
      if (l === 'merchant') return t('actor.merchant');
      if (l === 'restaurant') return t('actor.restaurant');
      const platformKeys = {
        'jahez': 'platformName.JAHEZ',
        'keeta': 'platformName.KEETA',
        'ninja': 'platformName.NINJA',
        'the chefz': 'platformName.THE_CHEFZ',
        'ninja  - staging': 'platformName.NINJA_STAGING',
        'ninja - staging': 'platformName.NINJA_STAGING',
        'chat agent': 'platformName.CHAT_AGENT',
        'order agent': 'platformName.CHAT_AGENT',
        'digital catalog': 'platformName.DIGITAL_CATALOG',
        'digital_catalog': 'platformName.DIGITAL_CATALOG',
        'digitalcatalog': 'platformName.DIGITAL_CATALOG',
        'chat_agent': 'platformName.CHAT_AGENT',
      };
      const key = platformKeys[l];
      return key ? t(key) : v;
    };
    const patterns = [
      { regex: /^Customer cancel(?:led|ed) the order\.?$/i, key: 'reason.customer.cancelled' },
      { regex: /^Order cancelled by customer\.?$/i, key: 'reason.customer.cancelled' },
      { regex: /^Customer requests order cancellation\.?$/i, key: 'reasonText.customer_requests_cancellation' },
      { regex: /^Restaurant did not respond in time\.?$/i, key: 'reasonText.restaurant_did_not_respond' },
      { regex: /^Order rejected by merchant\.?$/i, key: 'reasonText.order_rejected_by_merchant' },
      { regex: /^Order cancel(?:led|ed) by merchant\.?$/i, key: 'reasonText.order_cancelled_by_merchant' },
      { regex: /^Order rejected by restaurant\.?$/i, key: 'reasonText.order_rejected_by_restaurant' },
      { regex: /^Order cancel(?:led|ed) by restaurant\.?$/i, key: 'reasonText.order_cancelled_by_restaurant' },
      { regex: /^Out of stock\.?$/i, key: 'reasonText.out_of_stock' },
      { regex: /^Item not available\.?$/i, key: 'reasonText.item_not_available' },
      { regex: /^Store closed\.?$/i, key: 'reasonText.store_closed' },
      { regex: /^Preparation time exceeded\.?$/i, key: 'reasonText.preparation_time_exceeded' },
      { regex: /^Order created via Digital Catalog\.?$/i, key: 'reasonText.order_created_via_digital_catalog' },
      { regex: /^Order created via Order Agent\.?$/i, key: 'reasonText.order_created_via_order_agent' },
      { regex: /^Order created via (Chat Agent|AI Order Agent)\.?$/i, key: 'reasonText.order_created_via_chat_agent' },
      { regex: /^Order has been rejected by user$/i, key: 'reason.user.rejected' },
      { regex: /^Order has been cancelled by user$/i, key: 'reason.user.cancelled' },
      { regex: /^Order has been accepted by user$/i, key: 'reason.user.accepted' },
      { regex: /^Order has been marked as ready for delivery by user$/i, key: 'reason.user.ready_for_delivery' },
      { regex: /^Order has been marked as delivered by user$/i, key: 'reason.user.delivered' },
      { regex: /^Order status updated to (.+) by user$/i, key: 'reason.user.status_updated', vars: (m) => ({ status: m[1] }) },
      
      { regex: /^Order received from\s+([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.received_from_platform', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order has been rejected by ([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.rejected', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order has been cancelled by ([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.cancelled', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order has been accepted by ([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.accepted', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order has been marked as ready for delivery by ([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.ready_for_delivery', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order is out for delivery \(([^)]+)\)(?::\s+(.+))?$/i, key: 'reason.webhook.out_for_delivery', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Driver assigned to order (\d+) \(([^)]+)\)$/i, key: 'reason.webhook.driver_assigned_to_order', vars: (m) => ({ orderId: m[1], platform: normalizePlatform(m[2]) }) },
      { regex: /^Driver assigned \(([^)]+)\)$/i, key: 'reason.webhook.driver_assigned', vars: (m) => ({ platform: normalizePlatform(m[1]) }) },
      { regex: /^Order has been delivered \(([^)]+)\)(?::\s+(.+))?$/i, key: 'reason.webhook.delivered', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order timed out \(([^)]+)\)(?::\s+(.+))?$/i, key: 'reason.webhook.timed_out', vars: (m) => ({ platform: normalizePlatform(m[1]), reason: m[2] || '' }) },
      { regex: /^Order status updated to (.+) by ([^:]+)(?::\s+(.+))?$/i, key: 'reason.webhook.status_updated', vars: (m) => ({ status: m[1], platform: normalizePlatform(m[2]), reason: m[3] || '' }) },

      { regex: /^Order has been automatically accepted by system$/i, key: 'reason.system.auto_accepted' },
      { regex: /^Order has been automatically timed out due to no response$/i, key: 'reason.system.auto_timed_out' },
      { regex: /^Order timed out due to no response\s*\??\s*$/i, key: 'reason.system.timed_out_no_response' },
      { regex: /^Order Timed Out by System, not responding to it\.?$/i, key: 'reason.system.auto_timed_out' },
      { regex: /^Auto accepted by system$/i, key: 'reason.system.auto_accepted' },
      { regex: /^Auto time-out due to no response$/i, key: 'reason.system.auto_timed_out' },
      { regex: /^Order has been rejected$/i, key: 'reason.system.rejected' },
      { regex: /^Order has been cancelled$/i, key: 'reason.system.cancelled' },
      { regex: /^Order has been accepted$/i, key: 'reason.system.accepted' },
      { regex: /^Order status updated to (.+)$/i, key: 'reason.system.status_updated', vars: (m) => ({ status: m[1] }) },
    ];
    for (const p of patterns) {
      const m = reason.match(p.regex);
      if (m) {
        const vars = p.vars ? p.vars(m) : undefined;
        // Translate reason text if present
        if (vars?.reason && String(vars.reason).trim()) {
          vars.reason = translateReasonText(vars.reason);
        }
        // Use _with_reason key if reason text exists, otherwise use the base key
        const keyToUse = (vars?.reason && String(vars.reason).trim()) ? `${p.key}_with_reason` : p.key;
        const translated = t(keyToUse, vars);
        return translated;
      }
    }
    // Fallback: try to translate as generic reason text
    const translated = translateReasonText(reason);
    return translated;
  };

  if (loading) {
    return (
      <MDBContainer
        fluid
        className="p-4 content-area flex-grow-1 d-flex justify-content-center align-items-center"
      >
        <div className="text-center">
          <MDBIcon icon="circle-notch" spin size="2x" className="mb-3" />
          <p>Loading order details...</p>
        </div>
      </MDBContainer>
    );
  }

  if (error) {
    return (
      <MDBContainer fluid className="p-4 content-area flex-grow-1">
        <div className="alert alert-danger">
          <MDBIcon icon="exclamation-circle" className="me-2" />
          {error}
        </div>
        <Button color="primary" onClick={handleBack}>
          Back to Orders
        </Button>
      </MDBContainer>
    );
  }

  if (!orderDetails) {
    return null;
  }

  return (
    <MDBContainer fluid className="px-3 py-2 content-area flex-grow-1 order-billing-compact">
  <style>{`
    .order-billing-compact .card {
      border: 1px solid #dee2e6;
      box-shadow: none;
      border-radius: 6px;
    }
    .order-billing-compact .card-body {
      padding: 0.65rem 0.85rem;
    }
    .order-billing-compact .billing-section-title {
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #6c757d;
      margin-bottom: 0.5rem;
    }
    .order-billing-compact .billing-table td {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      font-size: 0.8rem;
      vertical-align: middle;
    }
    .order-billing-compact .billing-total-row td {
      font-size: 0.8125rem;
      padding-top: 0.5rem;
      color: #000 !important;
    }
    .order-billing-compact .billing-product-row {
      font-size: 0.8125rem;
    }
    .order-billing-compact .billing-order-items-table {
      font-size: 0.8125rem;
    }
    .order-billing-compact .billing-order-items-table thead th {
      font-size: 0.65rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #6c757d;
      border-bottom: 1px solid #dee2e6;
      padding: 0.35rem 0.25rem 0.45rem 0;
      vertical-align: bottom;
    }
    .order-billing-compact .billing-order-items-table tbody td {
      padding: 0.35rem 0.25rem;
      vertical-align: top;
    }
    .order-billing-compact .billing-order-items-table .col-num {
      text-align: end;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
      white-space: nowrap;
    }
    .order-billing-compact .billing-order-items-table tfoot td {
      font-size: 0.8125rem;
    }
    .order-billing-compact .billing-summary-table tbody td {
      padding-top: 0.3rem;
      padding-bottom: 0.3rem;
      font-size: 0.8rem;
      line-height: 1.35;
      vertical-align: middle;
    }
    .order-billing-compact .billing-summary-table tr.billing-total-row td {
      padding-top: 0.55rem;
      padding-bottom: 0.3rem;
    }
    .order-billing-compact .billing-table-2col {
      table-layout: fixed;
      width: 100%;
    }
    .order-billing-compact .billing-table-2col .billing-label-col {
      width: 62%;
      vertical-align: middle;
    }
    .order-billing-compact .billing-table-2col .billing-amount-col {
      width: 38%;
      text-align: end;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
      white-space: nowrap;
      vertical-align: middle;
    }
    .order-billing-compact .billing-table-2col .billing-amount-inner {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      gap: 0.35rem;
      width: 100%;
      font-variant-numeric: tabular-nums;
      font-feature-settings: "tnum";
    }
    .order-billing-compact .billing-table-2col .billing-amount-inner .price-display {
      flex-shrink: 0;
    }
  `}</style>
  <RightDrawer
  open={timelineOpen}
  onClose={() => setTimelineOpen(false)}
  title={t("ordercycle")}
  width="600px"
  placement={i18n.dir() === 'rtl' ? 'left' : 'right'}
  dir={i18n.dir() === 'rtl' ? 'rtl' : 'ltr'}
>
  <div style={{ padding: '8px' }}>
    <style>{`
      .drawer-summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        gap: 12px;
        color: black;
      }
      @media (max-width: 478px) {
        .drawer-summary-grid {
          grid-template-columns: 1fr;
        }
        .drawer-summary-grid .drawer-col {
          justify-self: start;
        }
      }
    `}</style>
    {/* Order Summary */}
    <div style={{ 
      display: "grid", 
      gap: 12, 
      marginBottom: '24px',
      padding: '16px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px'
    }}>
      <div className="drawer-summary-grid">
         <span className="drawer-col" style={{ fontWeight: 600, fontSize: '16px', display: 'inline-flex', alignItems: 'center', gap: 20 }}>
           <span>{t("status")}:</span>
           {getStatusBadge(orderDetails.status)}
         </span>
        <span className="drawer-col" style={{ fontWeight: 600, fontSize: '16px', display: 'inline-flex', alignItems: 'center', gap: 20 }}>
          <span>{t("platform")}:</span>
          {orderDetails.platform ? (
            <PlatformLogo platform={orderDetails.platform} />
          ) : (
            <span>{t("N/A", "N/A")}</span>
          )}
        </span>
      </div>
      <span style={{ fontWeight: 600, fontSize: '16px', display: 'inline-flex', alignItems: 'center', gap: 20, color: 'black' }}>
           <span>{t("reason")}:</span>
          <span style={{fontWeight: 400, fontSize: '14px', color: 'gray'}}>{translateReason(orderLogsData?.reason)}</span>
         </span>
         <span style={{ fontWeight: 600, fontSize: '16px', display: 'inline-flex', alignItems: 'center', gap: 20, color: 'black' }}>
         <span>{t("actor")}:</span>
          <span style={{fontWeight: 400, fontSize: '14px', marginLeft: 16, color: 'gray'}}>
            {(() => {
              const a = (orderLogsData?.actor || '').trim();
              if (!a) return '';
              const al = a.toLowerCase();
              if (al === 'system') return t('actor.system');
              if (al === 'delivery service') return t('actor.delivery_service');
              return a;
            })()}
          </span>
        </span>

        <div style={{ width: '100%', height: '1px', backgroundColor: '#dee2e6', margin: '8px 0' }} />
        <span style={{ fontWeight: 600, fontSize: '16px', display: 'inline-flex', alignItems: 'center', gap: 20, color: 'black' }}>
         <span>{t("timeline")}</span>
        </span>
        

    </div>

    <div style={{ position: 'relative', marginTop: 20 }}>
  {(() => {
    const events = mapLogsToTimeline(orderLogs);
    const dateLabel = events[0]?.datetime.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
    
    // consistent grid layout for alignment
    const isRTL = (i18n.language === 'ar' || i18n.dir() === 'rtl');
    const gridLayout = isRTL ? '100px 32px 1fr' : '100px 32px 1fr'; 

    return (
      <>
        {/* --- DATE LABEL ROW --- */}
        <div style={{ display: 'grid', gridTemplateColumns: gridLayout, gap: 16, alignItems: 'center' }}>
           {/* Column 1: Empty Time */}
          <div></div> 
          
          {/* Column 2: Date Pill & Line Start */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', height: '100%' }}>
            {/* The Date Pill */}
            <div style={{ 
              backgroundColor: '#0d2d3c', 
              color: '#fff', 
              borderRadius: 8, 
              padding: '6px 12px', 
              fontWeight: 600, 
              fontSize: 13,
              zIndex: 2, // Sits on top of the line
              whiteSpace: 'nowrap'
            }}>
              {dateLabel}
            </div>
            {/* The Line (Starts at middle of pill, goes down) */}
            <div style={{ 
              position: 'absolute', 
              top: '50%', 
              bottom: -16, // Extends down to meet the next item's top margin
              width: 2, 
              backgroundColor: '#dee2e6', 
              zIndex: 1 
            }} />
          </div>

          {/* Column 3: Empty Content */}
          <div></div>
        </div>

        {/* --- TIMELINE EVENTS --- */}
        {events.map((event, index, array) => {
           const isLastItem = index === array.length - 1;
          
           
           return (
            <div key={event.id} style={{ display: 'grid', gridTemplateColumns: gridLayout, gap: 16, paddingTop: 16 }}>
              {isRTL ? (
                <>
                  {/* Column 1: Time (RTL – rightmost overall but first column to place it near rail visually on the left-to-right grid) */}
                  <div style={{ fontSize: 12, color: '#6c757d', textAlign: 'right', paddingTop: 6 }}>
                    {event.datetime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                  </div>
                  {/* Column 2: Rail & Icon */}
                  <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ position: 'absolute', top: -16, bottom: isLastItem ? 'auto' : -16, height: isLastItem ? '24px' : 'auto', width: 2, backgroundColor: '#dee2e6', zIndex: 0 }} />
                    <div style={{ width: 32, height: 32, borderRadius: '50%', backgroundColor: (event.type === 'error') ? '#dc3545' : (event.type === 'timeout' ? '#C0C0C0' : (event.status === 'DELIVERED' ? '#dee2e6' : '#FF9B53')), display: 'flex', alignItems: 'center', justifyContent: 'center', color: (event.status === 'DELIVERED' ? '#0d2d3c' : '#fff'), fontSize: 12, zIndex: 2 }}>
                      {event.status === 'ACCEPTED' ? (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22" cy="22" r="22" fill="#F4A460" />
    <path d="M23 32H16C14.8954 32 14 31.1046 14 30V14C14 12.8954 14.8954 12 16 12H28C29.1046 12 30 12.8954 30 14V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 18H25" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M19 23H25" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M19 28H21" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M26 29L29 32L35 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
) : (
  <MDBIcon icon={event.icon} size="sm" />
)}
                    </div>
                  </div>
                  {/* Column 3: Content Card (RTL) */}
                  <div style={{ backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', padding: '12px 16px', marginBottom: 4 }}>
                    <div style={{ fontWeight: 700, color: '#0d2d3c', marginBottom: 4 }}>
                      {event.displayText}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', fontSize: 13, color: '#6c757d' }}>
                      <span style={{marginLeft: 2}}>{event.user || 'N/A'}</span>
                  {(['CANCELLED','REJECTED'].includes(event.status) && String(event.reason || '').trim()) && (
                    <span style={{marginLeft: 2}}>{t('reason')}: {String(event.reason).trim()}</span>
                  )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* Column 1: Time (LTR) */}
                  <div style={{ fontSize: 12, color: '#6c757d', textAlign: 'right', paddingTop: 6 }}>
                    {event.datetime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                  </div>
                  {/* Column 2: Rail & Icon */}
                  <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ position: 'absolute', top: -16, bottom: isLastItem ? 'auto' : -16, height: isLastItem ? '24px' : 'auto', width: 2, backgroundColor: '#dee2e6', zIndex: 0 }} />
                    <div style={{ width: 32, height: 32, borderRadius: '50%', backgroundColor: (event.type === 'error') ? '#dc3545' : (event.type === 'timeout' ? '#C0C0C0' : (event.status === 'DELIVERED' ? '#dee2e6' : '#FF9B53')), display: 'flex', alignItems: 'center', justifyContent: 'center', color: (event.status === 'DELIVERED' ? '#0d2d3c' : '#fff'), fontSize: 12, zIndex: 2 }}>
                      {event.status === 'ACCEPTED' ? (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22" cy="22" r="22" fill="#F4A460" />
    <path d="M23 32H16C14.8954 32 14 31.1046 14 30V14C14 12.8954 14.8954 12 16 12H28C29.1046 12 30 12.8954 30 14V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 18H25" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M19 23H25" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M19 28H21" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M26 29L29 32L35 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
) : (
  <MDBIcon icon={event.icon} size="sm" />
)}
                    </div>
                  </div>
                  {/* Column 3: Content Card (LTR) */}
                  <div style={{ backgroundColor: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', padding: '12px 16px', marginBottom: 4 }}>
                    <div style={{ fontWeight: 700, color: '#0d2d3c', marginBottom: 4 }}>
                      {event.displayText}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', fontSize: 13, color: '#6c757d' }}>
                      <span style={{marginLeft: 2}}>{event.user || 'N/A'}</span>
                      {(String(event.reason || '').trim()) && (
                        <span style={{marginLeft: 2}}>{t('reason')}: {String(event.reason).trim()}</span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </>
    );
  })()}
</div>

    {/* Completed Status */}
    {orderDetails.status === 'COMPLETED' || orderDetails.status === 'DELIVERED' ? (
      <div style={{
        padding: '16px',
        backgroundColor: '#d1e7dd',
        borderRadius: '8px',
        textAlign: 'center',
        marginTop: '16px'
      }}>
        <MDBIcon icon="check-circle" className="me-2" style={{ color: '#198754' }} />
        <span style={{ color: '#0f5132', fontWeight: 600 }}>
          {t('orderCompleted')}
        </span>
      </div>
    ) : null}
  </div>
</RightDrawer>
      <div className="d-flex justify-content-between align-items-center">
        <Actionbar
          title={t("orderdetails")}
          subtitle={t("manageyourorder")}
          firstBtnText={t("timeline")}
          firstBtnOnClick={handletimeline}
          firstBtnClass="ocean"
          firstBtnIcon="clock"
          secondBtnText={t("backtoorders")}
          secondBtnOnClick={handleBack}
          secondBtnClass="ocean"
          secondBtnIcon="back"
          thirdBtnText={t("print")}
          thirdBtnOnClick={handlePrint}
          thirdBtnClass="secondary"
          thirdBtnIcon="plus"
          
        />   
      </div>
      
    <div className="d-flex justify-content-end mb-2"> <div>
          {orderDetails.status === "PENDING" && (
            <>
              <Button
                color="success"
                size="sm"
                className="me-2"
                disabled={isUpdating}
                onClick={() => handleStatusUpdate("ACCEPTED")}
              >
                <MDBIcon icon="check" className="me-2" />{" "}
                {isUpdating ? t("Accepting...") : t("accept")}
              </Button>
              <Button
                color="danger"
                size="sm"
                className="me-2"
                disabled={isUpdating}
                onClick={() => handleStatusUpdate("REJECTED")}
              >
                <MDBIcon icon="times" className="me-2" />{" "}
                {isUpdating ? t("Rejecting...") : t("reject")}
              </Button>
            </>
          )}
        </div></div>
      <MDBCard className="mb-2">
        <MDBCardBody>
          <MDBCardTitle tag="div" className="billing-section-title">{t("ordersummary")}</MDBCardTitle>
          <MDBRow className="g-2">
            <MDBCol md="6">
              <MDBTable borderless className="mb-0 billing-table">
                <MDBTableBody>
                  <tr>
                    <td>
                      <strong>{t("orderId")}:</strong>
                    </td>
                    <td>{orderDetails.order_id}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>
                        {orderDetails.platform &&
                        ['DIGITAL_CATALOG', 'CHAT_AGENT'].includes(
                          String(orderDetails.platform).toUpperCase()
                        )
                          ? `${t("External ID")}:`
                          : orderDetails.platform
                            ? `${orderDetails.platform.charAt(0).toUpperCase()}${orderDetails.platform.slice(1).toLowerCase()} ID:`
                            : null}
                      </strong>
                    </td>
                    <td>
                      {orderDetails.jahez_id ||
                        orderDetails.chat_agent_external_id ||
                        '—'}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{t("status")}:</strong>
                    </td>
                    <td>{getStatusBadge(`${t(orderDetails.status)}`)}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{t("platform")}:</strong>
                    </td>
                    <td>{orderDetails.platform}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{t("store")}:</strong>
                    </td>
                    <td>{orderDetails.store.name}</td>
                  </tr>
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
            <MDBCol md="6">
              <MDBTable borderless className="mb-0 billing-table">
                <MDBTableBody>
                  <tr>
                    <td>
                      <strong>{t("customer")}:</strong>
                    </td>
                    <td>{orderDetails.customer_name}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{t("paymentmethod")}:</strong>
                    </td>
                    <td>{t(orderDetails.payment_method)}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{t("createdAt")}:</strong>
                    </td>
                    <td>{formatDate(orderDetails.createdAt)}</td>
                  </tr>
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
          </MDBRow>
        </MDBCardBody>
      </MDBCard>

     <MDBCard className="mb-2">
  <MDBCardBody>
    <MDBCardTitle tag="div" className="billing-section-title">{t("orderitems")}</MDBCardTitle>
    <MDBTable responsive borderless className="mb-0 billing-order-items-table billing-table">
      <colgroup>
        <col />
        <col style={{ width: "3.25rem" }} />
        <col style={{ width: "6.75rem" }} />
        <col style={{ width: "7rem" }} />
      </colgroup>
      <MDBTableHead>
        <tr>
          <th scope="col" style={{ minWidth: "8rem" }}>{t("products")}</th>
          <th scope="col" className="col-num" style={{ width: "3.25rem" }}>{t("Qty")}</th>
          <th scope="col" className="col-num" style={{ width: "6.75rem" }}>{t("Unit Price")}</th>
          <th scope="col" className="col-num" style={{ width: "7rem" }}>{t("total")}</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        {orderDetails.products.map((product, index) => {
          const qty = Math.max(1, Number(product.quantity) || 1);
          const lineTotal = Number(product.final_price) || 0;
          const unitPrice = qty > 0 ? lineTotal / qty : lineTotal;
          return (
            <React.Fragment key={index}>
              <tr className="billing-product-row">
                <td>
                  <div className="d-flex align-items-start gap-2">
                    <img
                      src={getImageUrl(product.product_details.image_path)}
                      alt={product.product_details.name.en}
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        flexShrink: 0,
                      }}
                      onError={(e) => {
                        e.currentTarget.src = "/default.jpg";
                      }}
                    />
                    <div className="min-w-0" style={{ wordBreak: "break-word" }}>
                      <div className="fw-semibold">
                        {isArabic ? product.product_details.name.ar : product.product_details.name.en}
                      </div>
                      {(product.product_details.category_id) && (
                        <div className="text-muted" style={{ fontSize: "0.72rem" }}>
                          {isArabic ? product.product_details.category_id?.name.ar : product.product_details.category_id?.name.en}
                        </div>
                      )}
                      <div className="text-muted" style={{ fontSize: "0.72rem" }}>
                        {t("SKU")}: {product.product_id}
                      </div>
                      {product.notes && (
                        <div className="text-warning mt-1" style={{ fontSize: "0.72rem", wordBreak: "break-word" }}>
                          <MDBIcon icon="sticky-note" className="me-1" />
                          {product.notes}
                        </div>
                      )}
                    </div>
                  </div>
                </td>
                <td className="col-num">{qty}</td>
                <td className="col-num">
                  <PriceDisplay
                    value={unitPrice.toFixed(2)}
                    className="mb-0"
                    style={{ fontSize: "0.8125rem", justifyContent: "flex-end" }}
                    iconSize="11"
                    color="#000"
                  />
                </td>
                <td className="col-num fw-semibold">
                  <PriceDisplay
                    value={lineTotal.toFixed(2)}
                    className="mb-0"
                    style={{ fontSize: "0.8125rem", justifyContent: "flex-end" }}
                    iconSize="11"
                    color="#000"
                  />
                </td>
              </tr>
              {product.modifiers && product.modifiers.length > 0 && product.modifiers.map((modifier, mIndex) =>
                modifier.options.map((option, oIndex) => {
                  const optQty = Math.max(1, Number(option.quantity) || 1);
                  const optUnit = Number(option.final_price) || 0;
                  const optLine = optUnit * optQty;
                  return (
                    <tr key={`${index}-m${mIndex}-o${oIndex}`} className="billing-modifier-row">
                      <td className="ps-4" style={{ fontSize: "0.75rem", color: "#adb5bd" }}>
                        + {isArabic ? option.nameAr : option.nameEn}
                      </td>
                      <td className="col-num" style={{ fontSize: "0.75rem", color: "#adb5bd" }}>{optQty}</td>
                      <td className="col-num" style={{ fontSize: "0.75rem", color: "#adb5bd" }}>
                        <PriceDisplay
                          value={optUnit.toFixed(2)}
                          className="mb-0"
                          style={{ fontSize: "0.75rem", justifyContent: "flex-end", color: "#adb5bd" }}
                          iconSize="10"
                          color="#adb5bd"
                        />
                      </td>
                      <td className="col-num" style={{ fontSize: "0.75rem", color: "#adb5bd" }}>
                        <PriceDisplay
                          value={optLine.toFixed(2)}
                          className="mb-0"
                          style={{ fontSize: "0.75rem", justifyContent: "flex-end", color: "#adb5bd" }}
                          iconSize="10"
                          color="#adb5bd"
                        />
                      </td>
                    </tr>
                  );
                })
              )}
            </React.Fragment>
          );
        })}
      </MDBTableBody>
      <tfoot>
        <tr>
          <td className="border-top col-num pt-2 pb-2 fw-bold text-dark text-end align-middle" colSpan={3}>
            {t("subtotal")}:
          </td>
          <td className="col-num border-top pt-2 pb-2 fw-bold align-middle">
            <PriceDisplay
              value={sumOrderLineFinalPrices(orderDetails.products).toFixed(2)}
              color="#000"
              iconSize="11"
              className="fw-bold"
              style={{ justifyContent: "flex-end", width: "100%", fontWeight: 700 }}
            />
          </td>
        </tr>
      </tfoot>
    </MDBTable>
  </MDBCardBody>
</MDBCard>

     <MDBRow className="g-2 mt-1">
  {/* Always show customer fees card */}
  <MDBCol md={orderDetails.platform?.toLowerCase() === 'keeta' ? 6 : 12}>
    <MDBCard className="h-100">
      <MDBCardBody>
        <MDBCardTitle tag="div" className="billing-section-title">{t("paymentsummary")}</MDBCardTitle>
        <MDBTable borderless className="mb-0 billing-table billing-table-2col billing-summary-table">
          <colgroup>
            <col className="billing-label-col" />
            <col className="billing-amount-col" />
          </colgroup>
          <MDBTableBody>
             {orderDetails.platform?.toLowerCase() === 'keeta' && (
            <tr>
              <td className="billing-label-col">
                <strong>{t("price")}:</strong>
              </td>
              <td className="billing-amount-col">
                <div className="billing-amount-inner">
                  <PriceDisplay
                    value={(orderDetails.customer_fees?.product_price || orderDetails.price).toFixed(2)}
                    color="#000"
                    iconSize="11"
                    style={{ justifyContent: "flex-end" }}
                  />
                </div>
              </td>
            </tr>)}

            {/* Only show these additional fields for Keeta platform */}
            {orderDetails.platform?.toLowerCase() === 'keeta' && (
              <>
                <tr>
                  <td className="billing-label-col">
                    <strong>{t("deliveryfee")}:</strong>
                  </td>
                  <td className="billing-amount-col">
                    <div className="billing-amount-inner">
                      <PriceDisplay
                        value={(orderDetails.customer_fees?.delivery_fee || 0).toFixed(2)}
                        color="#000"
                        iconSize="11"
                        style={{ justifyContent: "flex-end" }}
                      />
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="billing-label-col">
                    <strong>{t("paltformservicefees")}:</strong>
                  </td>
                  <td className="billing-amount-col">
                    <div className="billing-amount-inner">
                      <PriceDisplay
                        value={(orderDetails.merchant_fees?.platform_service_fee || 0).toFixed(2)}
                        color="#000"
                        iconSize="11"
                        style={{ justifyContent: "flex-end" }}
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="billing-label-col">
                    <strong>{t("tips")}:</strong>
                  </td>
                  <td className="billing-amount-col">
                    <div className="billing-amount-inner">
                      <PriceDisplay
                        value={(orderDetails.customer_fees?.tips || 0).toFixed(2)}
                        color="#000"
                        iconSize="11"
                        style={{ justifyContent: "flex-end" }}
                      />
                    </div>
                  </td>
                </tr>
                
                <tr>
                  <td className="billing-label-col">
                    <strong>{t("Top-up Amount")}:</strong>
                  </td>
                  <td className="billing-amount-col">
                    <div className="billing-amount-inner">
                      <PriceDisplay
                        value={(orderDetails.customer_fees?.top_up_amount || 0).toFixed(2)}
                        color="#000"
                        iconSize="11"
                        style={{ justifyContent: "flex-end" }}
                      />
                    </div>
                  </td>
                </tr>
              </>
            )}

            <tr className="border-top billing-total-row">
              <td className="billing-label-col">
                <strong className="text-dark">{t("total")} {orderDetails.platform?.toLowerCase() === 'keeta' ? `${t("paid")}` : `${t("price")}`}:</strong>
              </td>
              <td className="billing-amount-col fw-bold text-dark">
                <div className="billing-amount-inner fw-bold">
                  <PriceDisplay
                    value={
                      orderDetails.platform?.toLowerCase() === "keeta"
                        ? computeKeetaPaymentSummaryTotal(orderDetails).toFixed(2)
                        : (orderDetails.customer_fees?.total_paid || orderDetails.final_price).toFixed(2)
                    }
                    color="#000"
                    iconSize="11"
                    className="fw-bold"
                    style={{ justifyContent: "flex-end", fontWeight: 700 }}
                  />
                </div>
              </td>
            </tr>
          </MDBTableBody>
        </MDBTable>
      </MDBCardBody>
    </MDBCard>
  </MDBCol>

  {/* Only show merchant fees card for Keeta platform */}
  {orderDetails.platform?.toLowerCase() === 'keeta' && (
    <MDBCol md="6">
      <MDBCard className="h-100">
        <MDBCardBody>
          <MDBCardTitle tag="div" className="billing-section-title">{t("merchantfees")}</MDBCardTitle>
          <MDBTable borderless className="mb-0 billing-table billing-table-2col billing-summary-table">
            <colgroup>
              <col className="billing-label-col" />
              <col className="billing-amount-col" />
            </colgroup>
            <MDBTableBody>
              <tr>
                <td className="billing-label-col">
                  <strong>{t("price")}:</strong>
                </td>
                <td className="billing-amount-col">
                  <div className="billing-amount-inner">
                    <PriceDisplay
                      value={(orderDetails.merchant_fees?.product_price || orderDetails.price).toFixed(2)}
                      color="#000"
                      iconSize="11"
                      style={{ justifyContent: "flex-end" }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="billing-label-col">
                  <strong>{t("banktransactionfee")}:</strong>
                </td>
                <td className="billing-amount-col text-danger">
                  <div className="billing-amount-inner">
                    <span aria-hidden="true">−</span>
                    <PriceDisplay
                      value={(orderDetails.merchant_fees?.bank_transaction_fee || 0).toFixed(2)}
                      color="#dc3545"
                      iconSize="11"
                      style={{ justifyContent: "flex-end" }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="billing-label-col">
                  <strong>{t("brokeragefee")}:</strong>
                </td>
                <td className="billing-amount-col text-danger">
                  <div className="billing-amount-inner">
                    <span aria-hidden="true">−</span>
                    <PriceDisplay
                      value={(orderDetails.merchant_fees?.brokerage_fee || 0).toFixed(2)}
                      color="#dc3545"
                      iconSize="11"
                      style={{ justifyContent: "flex-end" }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="billing-label-col">
                  <strong>{t("activityfees")}:</strong>
                </td>
                <td className="billing-amount-col text-danger">
                  <div className="billing-amount-inner">
                    <span aria-hidden="true">−</span>
                    <PriceDisplay
                      value={(orderDetails.merchant_fees?.activity_fee || 0).toFixed(2)}
                      color="#dc3545"
                      iconSize="11"
                      style={{ justifyContent: "flex-end" }}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className="billing-label-col">
                  <strong>{t("Top-up Amount")}:</strong>
                </td>
                <td className="billing-amount-col">
                  <div className="billing-amount-inner">
                    <PriceDisplay
                      value={(orderDetails.merchant_fees?.top_up_amount || 0).toFixed(2)}
                      color="#000"
                      iconSize="11"
                      style={{ justifyContent: "flex-end" }}
                    />
                  </div>
                </td>
              </tr>
              <tr className="border-top billing-total-row">
                <td className="billing-label-col">
                  <strong className="text-dark">{t("totalmerchantreceives")}:</strong>
                </td>
                <td className="billing-amount-col fw-bold text-dark">
                  <div className="billing-amount-inner fw-bold">
                    <PriceDisplay
                      value={computeKeetaMerchantReceivesTotal(orderDetails).toFixed(2)}
                      color="#000"
                      iconSize="11"
                      className="fw-bold"
                      style={{ justifyContent: "flex-end", fontWeight: 700 }}
                    />
                  </div>
                </td>
              </tr>
            </MDBTableBody>
          </MDBTable>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  )}
</MDBRow>

      </MDBContainer>
  );
}

export default ViewOrderDetails;
